<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Distribución de porcentaje de cuotas (para fines tributarios)
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>
          </md-card-content> 
        </md-card> 

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('porcentajecuotas')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Porcentaje de Cuotas del Titular *
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Indicar el porcentaje de la inversión que corresponderá a la persona que está completando este formulario. Dicho porcentaje será utilizado en la
              retención del impuesto a la renta al momento del rescate.
              <br/>
              <br/>
              EN CASO DE SOCIEDAD CONYUGAL, las opciones son solo: 50%-50% o 100%-0%.
            </p>              
            <div>            

              <div class="md-layout md-gutter">
                <!--
                <div class="md-layout-item">
                  <ejs-numerictextbox :value="form.porcentajecuotas" v-model="form.porcentajecuotas" :decimals="0" :min="0" :max="100" :showSpinButton="false" format="n" />
                </div>
                -->
                
                <div class="md-layout-item">
                  <ejs-numerictextbox :min="0" :value="val1" :max="100" format="n" :step="1" @change="ooo"></ejs-numerictextbox>
                  <div class="md-layout-item"><b>Titular</b></div>
                </div>
                <div class="md-layout-item">
                  <ejs-numerictextbox  :min="0" :value="val2" :max="100" format="n" :step="1" @change="uuu"></ejs-numerictextbox>
                  <div class="md-layout-item"><b>Mancomuno(s)</b></div>
                </div>
                
              </div>

              <div class="radioform" :class="getValidationClass('porcentajecuotas')">
                <span class="md-error" v-if="!$v.form.porcentajecuotas.required">El porcentaje de cuotas debe sumar al 100%</span>
              </div>                   

            </div>
          </md-card-content> 
        </md-card>                             

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>   

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  requiredIf,
} from 'vuelidate/lib/validators'

export default {
  mixins: [validationMixin],
  name: 'Item11',
  data: () => ({
    form:{
    },
    val1:0,val2:0,
  }),
  props: ["title", "data"],
  mounted: function(){
    this.form = this.$store.state.item.item11
    this.unjoinPorcentaje(this.form.porcentajecuotas)
  },
  validations(){
    var that = this
    var validate = {
      form: {
        porcentajecuotas: {
          required: requiredIf(function(){
            var final = that.val1 + that.val2
            return (final < 100)
          })
        }
      }        
    }
    return validate;
  },
  methods: {
    ooo(e){
      this.val2 = 100 - e.value
      this.joinPorcentaje()
    },
    uuu(e){
      this.val1 = 100 - e.value
      this.joinPorcentaje()
    },
    joinPorcentaje(){
      var str = ""
      this.form.porcentajecuotas = str.concat(this.val1, ",", this.val2)
    },
    unjoinPorcentaje(val){
      try{
        var str = val.split(",")
        this.val1 = parseInt(str[0])
        this.val2 = parseInt(str[1])
      }
      catch(e){
        this.val1=0
        this.val2=0
      }
    },    
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item11
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        var index= "0";
        if(this.$store.state.item.item9.titularidad == "Individual"){
          if(this.$store.state.item.item10.personanatutalinstitucional == "Si"){
            if(this.data.name == "Participe"){
              index= "14";
            }else{
              index= "16";
            }            
          }else{
            index= "13";
          }
        }else{
          index= "10";
        }
        this.$emit('setSaveForm', {id:"11", form: this.form, index: index});
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
